import type { WorkspaceProgress } from "../app/warm-workspace";
import { Progress } from "./ui/progress";

const phaseProgress: Record<WorkspaceProgress["phase"], number> = {
  access: 28,
  authenticating: 10,
  degraded: 100,
  ready: 100,
  session: 20,
  warming: 35,
};

export function WorkspaceStartup({ progress }: { progress: WorkspaceProgress }) {
  const warmFraction = progress.total ? progress.completed / progress.total : 0;
  const value =
    progress.phase === "warming"
      ? 35 + Math.round(warmFraction * 60)
      : phaseProgress[progress.phase];
  return (
    <main className="grid min-h-screen place-items-center bg-muted/30 p-6">
      <section
        aria-busy="true"
        aria-labelledby="workspace-progress-title"
        className="w-full max-w-sm space-y-4"
      >
        <div className="space-y-2" role="status" aria-live="polite">
          <h1 className="text-xl font-semibold" id="workspace-progress-title">
            {progress.label}
          </h1>
        </div>
        <Progress
          aria-label="Workspace preparation progress"
          aria-valuemax={100}
          aria-valuemin={0}
          aria-valuenow={value}
          value={value}
        />
      </section>
    </main>
  );
}

export function RouteLoadingPanel({ label }: { label: string }) {
  return (
    <section aria-busy="true" className="min-h-40 max-w-sm space-y-4 py-6" role="status">
      <h2 className="text-lg font-semibold">Opening {label}</h2>
      <Progress aria-label={`Opening ${label}`} value={70} />
    </section>
  );
}
